import { NgModule } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { HttpInterceptorService } from './http-interceptor.service';

@NgModule({
    providers: [AuthenticationService, HttpInterceptorService]
})
export class AuthenticationModule {}
